<template>
  <apexchart type="line" :options="soundChart" :series="soundSeries" :height="height" :width="width"></apexchart>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";

Vue.component("apexchart", VueApexCharts);

export default {
  props: {
    soundSeries: Array,
    height: Number,
    width: Number,
  },
  data() {
    return {
      soundChart: {
        chart: {
          id: "sound",
          group: "smp",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          tooltip: {
            enabled: false,
          },
          type: "datetime",
          labels: {
            datetimeUTC: false,
            style: {
              fontSize: "12px",
              colors: "primary",
            },
          },
        },

        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
          theme: true,
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "bottom",
          labels: {
            colors: "primary",
          },
        },
        yaxis: {
          min: 0,
          max: 120,
          tickAmount: 6,
          axisTicks: {
            show: true,
          },
          labels: {
            offsetX: -17,
            style: {
              fontSize: "12px",
              colors: "primary",
            },
            formatter: (val) => {
              return val.toFixed(1) + " dBA";
            },
          },
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
      },
    };
  },
};
</script>